import { motion } from 'framer-motion';

const Mission = ({ content }) => {
  if (!content) return null;

  const paragraphs = content.mission_text?.split('\n\n') || [];

  return (
    <section className="py-20 bg-white overflow-hidden" data-testid="mission-section">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl text-center">
        {/* Decorative line */}
        <motion.div
          className="w-16 h-1 bg-[#F6BF58] mx-auto mb-8"
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true, margin: "-80px" }}
        />

        <motion.h2
          className="text-3xl sm:text-4xl font-bold text-slate-900 mb-8"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          viewport={{ once: true, margin: "-80px" }}
          data-testid="mission-title"
        >
          {content.mission_title}
        </motion.h2>
        <div className="space-y-6">
          {paragraphs.map((paragraph, index) => (
            <motion.p
              key={index}
              className="text-lg text-slate-600 leading-relaxed"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 + index * 0.12 }}
              viewport={{ once: true, margin: "-80px" }}
              data-testid={`mission-text-${index}`}
            >
              {paragraph}
            </motion.p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Mission;
